module.exports = __webpack_public_path__ + "fonts/icomoon-app.0c0375ee.woff";